var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsGuestDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeOpacity: 0.01,
    strokeWidth: 0.01,
    d: "M0 0h24v24H0V0z",
    transform: "translate(-351 -1685) translate(0 1161) translate(341 512) translate(10 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F1015",
    d: "M8.976 9c.024-1.5-.895-2-2-2-1.104 0-1.976.5-2 2-.024 1.5.896 2 2 2 1.105 0 1.976-.5 2-2zm-6 0c.024-3 1.791-4 4-4 2.21 0 4.024 1 4 4-.024 3-1.79 4-4 4-2.209 0-4.024-1-4-4zm15-2c.024-1.5-.895-2-2-2-1.104 0-1.976.5-2 2-.024 1.5.896 2 2 2 1.105 0 1.976-.5 2-2zm-6 0c.024-3 1.791-4 4-4 2.21 0 4.024 1 4 4-.024 3-1.79 4-4 4-2.209 0-4.024-1-4-4zm-7.533 9.52c.057-.202.416-.473.627-.473h3.86c.217 0 .568.266.627.473l1.273 4.527h2.078l-1.426-5.068c-.302-1.073-1.443-1.932-2.552-1.932H5.07c-1.105 0-2.252.865-2.552 1.932l-1.426 5.068H3.17l1.273-4.527zM20 18.892h2l-1.45-5C20.245 12.85 19.104 12 18.001 12h-4.004C12.894 12 12 12.882 12 13.97h6.002c.21 0 .566.264.624.463L20 18.893z",
    transform: "translate(-351 -1685) translate(0 1161) translate(341 512) translate(10 12)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGuestDouble);
export default __webpack_public_path__ + "static/media/icons-guest-double.cd408f2b3a3ef4a42374ea027146504f.svg";
export { ForwardRef as ReactComponent };